import api, {
  buildActivityScopeHeaders,
  buildCompanyScopeHeaders,
} from "./api";


function buildStudioScopeHeaders({
  companyUuid,
  activityUuid,
} = {}) {
  return {
    ...buildCompanyScopeHeaders(
      companyUuid
    ),

    ...buildActivityScopeHeaders(
      activityUuid
    ),
  };
}


export const listStudioDocuments = ({
  companyUuid,
  activityUuid,
} = {}) =>
  api.get(
    "/studio/documents",
    {
      headers:
        buildStudioScopeHeaders({
          companyUuid,
          activityUuid,
        }),
    }
  );


export const fetchStudioDocument = (
  documentId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.get(
    `/studio/documents/${encodeURIComponent(documentId)}`,
    {
      headers:
        buildStudioScopeHeaders({
          companyUuid,
          activityUuid,
        }),
    }
  );


export const saveStudioDocument = (
  documentId,
  serializedDocument,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.put(
    `/studio/documents/${encodeURIComponent(documentId)}`,
    serializedDocument,
    {
      headers:
        buildStudioScopeHeaders({
          companyUuid,
          activityUuid,
        }),
    }
  );


export const deleteStudioDocument = (
  documentId,
  {
    companyUuid,
    activityUuid,
  } = {}
) =>
  api.delete(
    `/studio/documents/${encodeURIComponent(documentId)}`,
    {
      headers:
        buildStudioScopeHeaders({
          companyUuid,
          activityUuid,
        }),
    }
  );
